import { SvgIcon, Typography, makeStyles } from "components/mui-core";
import Tooltip from "components/Tooltip";
import { CreativeStatus } from "model/creative";
import React from "react";
import {
  dangerColor,
  grayColor,
  successColor,
} from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles({ index: 1 })({
  status: {
    fontSize: 13,
    fontWeight: "lighter",
    textTransform: "capitalize",
    height: 20,

    //text
    [`&.${CreativeStatus.Loading}`]: {
      color: grayColor[0],
    },
    [`&.${CreativeStatus.Live}`]: {
      color: successColor[0],
    },
    [`&.${CreativeStatus.NotLive}`]: {
      color: dangerColor[0],
    },

    //svg
    [`&.${CreativeStatus.Loading} svg`]: {
      color: grayColor[0],
    },
    [`&.${CreativeStatus.Live} svg`]: {
      color: successColor[0],
    },
    [`&.${CreativeStatus.NotLive} svg`]: {
      color: dangerColor[0],
    },
  },
  statusIcon: {
    height: "10px !important",
    width: "10px !important",
    marginRight: 4,
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

type IProps = {
  status?: CreativeStatus;
  statusLabel?: string | React.ReactNode;
  statusTooltip?: string;
  className?: string;
  width?: string;
  height?: string;
  tooltipOnlyOnBadge?: boolean;
};

function CreativeStatusBadge({
  status,
  statusTooltip,
  statusLabel,
  className,
  width,
  height,
  tooltipOnlyOnBadge,
}: IProps) {
  const { classes, cx } = useStyles();

  if (!status) {
    return null;
  }

  return (
    <Typography
      className={cx(classes.status, classes.ellipsis, status, className)}
      style={{ width, height }}
      variant="body2">
      {tooltipOnlyOnBadge ? (
        <>
          <Tooltip
            arrow
            title={statusTooltip}
            placement="top">
            <SvgIcon className={cx(classes.statusIcon, "statusIcon")}>
              <circle
                cx="12"
                cy="12"
                r="12"
              />
            </SvgIcon>
          </Tooltip>

          <span data-qa="status">{statusLabel ?? status}</span>
        </>
      ) : (
        <Tooltip
          arrow
          title={statusTooltip}
          placement="top">
          <SvgIcon className={cx(classes.statusIcon, "statusIcon")}>
            <circle
              cx="12"
              cy="12"
              r="12"
            />
          </SvgIcon>
          <span data-qa="status">{statusLabel ?? status}</span>
        </Tooltip>
      )}
    </Typography>
  );
}

export default CreativeStatusBadge;
